import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent extends BaseComponent implements OnInit {

  registerModalContent:string = "registerChoice";
  facebookResponse = {};
  inviteCode: string = "";

  @ViewChild('loginModal', {static: false}) loginModal;
  @ViewChild('registerModal', {static: false}) registerModal;
  @ViewChild('resetPasswordModal', {static: false}) resetPasswordModal;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  openLogin() {
    this.loginModal.open();
  }

  checkForInviteCode() {
    //An invite code is only valid for 72 hours
    const lastInviteTime: number = StorageHelper.getInstance().get(StorageHelper.keys.inviteCodeTime);
    const inviteCode: string = StorageHelper.getInstance().get(StorageHelper.keys.inviteCode);
    if(inviteCode && lastInviteTime) {
      const nowTime  = new Date().getTime();
      const senventyTwoHoursInMs = 72 * 60 * 60 * 1000;
      if(nowTime - lastInviteTime <= senventyTwoHoursInMs) {
        this.inviteCode = inviteCode;
      }
      else {
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCode);
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCodeTime);
      }
      if(this.inviteCode) { this.registerModalContent = 'register'; }
    }
  }

  openRegister() {
    this.checkForInviteCode();
    this.registerModal.open();
  }

  switchLoginToRegister() {
    this.loginModal.close();
    this.registerModal.open();
  }

  switchToLogin() {
    this.registerModal.close();
    this.loginModal.open();
  }

  onLoginSuccess() {
    window.location.reload();
  }

  resetPasswordClicked() {
    this.loginModal.close();
    this.resetPasswordModal.open();
  }

  loginClickedFromRegisterSuccess() {
    this.registerModal.close();
    this.loginModal.open();
  }

  connectedWithFacebook(response) {
    this.facebookResponse = response;
    this.registerModalContent = "registerUsername";
  }

}
